export default __webpack_public_path__ + "static/media/app-logo.de75ae4a.png";